export default __webpack_public_path__ + "static/media/icon.8bbc7088.png";